<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 20 })
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.5 5.3A16.3 16.3 0 0 0 15.4 4l-.5 1.1a15.1 15.1 0 0 0-4.8 0L9.5 4a16.6 16.6 0 0 0-4.1 1.3C2.8 9.2 2.1 13 2.4 16.8a16.7 16.7 0 0 0 5 2.5l1.2-1.7-1.9-.9.5-.4a11.7 11.7 0 0 0 9.6 0l.5.4-1.9.9 1.2 1.7a16.6 16.6 0 0 0 5-2.5c.4-4.4-.7-8.2-2.1-11.5ZM8.8 14.7c-1.4 0-2.5-1.3-2.5-2.8 0-1.6 1.1-2.8 2.5-2.8s2.5 1.3 2.5 2.8c0 1.6-1.1 2.8-2.5 2.8Zm6.4 0c-1.4 0-2.5-1.3-2.5-2.8 0-1.6 1.1-2.8 2.5-2.8s2.5 1.3 2.5 2.8c0 1.6-1.1 2.8-2.5 2.8Z" />
  </svg>
</template>
